import { render, staticRenderFns } from "./LoadingMA.vue?vue&type=template&id=683f009c&"
import script from "./LoadingMA.vue?vue&type=script&lang=js&"
export * from "./LoadingMA.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMA.vue?vue&type=style&index=0&id=683f009c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports